import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { CloseButton, CreateChancel, SelectTypeAutocomplete, ToastScreen } from 'components';
import { FindError, FindLoad, FindSuccess, useGlobalTextStyles, usePrimaryModal } from 'utils';
import { ACTION_TYPE_MOVE_BATCH, batchStatusesEnum } from './constants';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, loadActions } from 'store';


export const MoveTo = (
  {
    batchesListFromBatches, fromBatch, handleClose, selectedLoads, afterSuccess = () => {
  },
  }) => {
  const [currentBatchId, setCurrentBatchId] = useState(null);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const { batchesAllList } = useSelector((state) => ({
    batchesAllList: state?.loads?.batchesAllList?.batches,
  }));

  const { closePrimary } = usePrimaryModal();
  const loading = FindLoad(ACTION_TYPE_MOVE_BATCH);
  const success = FindSuccess(ACTION_TYPE_MOVE_BATCH);
  const beckError = FindError(ACTION_TYPE_MOVE_BATCH);
  const globalText = useGlobalTextStyles();

  const renderParams = () => {
    return {
      status: batchStatusesEnum.UNPAID,
    };
  };


  useEffect(() => {
    if (beckError?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_MOVE_BATCH));

      toast(
        <ToastScreen
          type={'error'}
          text={beckError?.[0]?.error}
        />,
      );
    }

  }, [beckError?.[0]?.error]);

  useEffect(() => {
    if (success?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_MOVE_BATCH));
      closePrimary();
      afterSuccess();
    }
  }, [success]);

  useEffect(() => {
    if (!batchesListFromBatches?.length) {
      dispatch(loadActions.getAllBatches(renderParams()));
    }
  }, []);


  const handleSelect = (e) => {
    setCurrentBatchId(e?.target?.value);
    setError('');
  };

  const handleCreate = () => {
    if (currentBatchId) {
      const body = {
        loadIds: selectedLoads?.map((load) => load?.id),
      };
      if (fromBatch) body.fromBatchId = fromBatch;
      dispatch(loadActions.moveLoadsPayableBatches(currentBatchId, body));
    } else {
      setError('displayIdString');
    }
  };

  return (
    <div className='move-to-wrapper'>
      <div className='move-to-close-btn'>
        <CloseButton handleCLic={handleClose} />
      </div>

      <p className={globalText.modalTitle} style={{ marginBottom: 32 }}>
        Move to
      </p>

      <SelectTypeAutocomplete
        loadType={'GET_BATCHES'}
        name={'displayIdString'}
        defaultValue={currentBatchId}
        label={'name'}
        title={'Select Batch Name *'}
        handleSelect={handleSelect}
        list={batchesListFromBatches ? batchesListFromBatches : batchesAllList}
        error={error}
        alwaysError={true}
      />

      <CreateChancel
        loader={!!loading?.length}
        create={'Move'}
        chancel={'Cancel'}
        onCreate={handleCreate}
        onClose={handleClose}
        width='100%'
      />
    </div>
  );
};

